import * as THREE from 'three';

/** Get all objects in the hierarchy that match the test function. */
export const getObjects = (
  object: THREE.Object3D,
  testFn: (node: THREE.Object3D) => boolean,
): THREE.Object3D[] => {
  const results: THREE.Object3D[] = [];
  object.traverse((obj) => {
    if (testFn(obj)) {
      results.push(obj);
    }
    return false;
  });
  return results;
};
